import React from 'react'
import PropTypes from 'prop-types'

export default function SplittedTitle({preKey, value,  postKey, testId}) {
    return <div className="text-center mb-4">
        <h1 className="h4"
            data-test-id={testId + '-head'}>
            {preKey + " " + value + " " + postKey}
        </h1>
    </div>
}

SplittedTitle.propTypes = {
    preKey: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    postKey: PropTypes.string,
    testId: PropTypes.string.isRequired
}